export const configureLightbox = (
  gantt,
  setSelectedTask,
  setCategoryModal,
  router,
  setTaskModal,
  setSelectedDetails
) => {
  gantt.showLightbox = (id) => {
    const task = gantt.getTask(id);
    console.log(task, 'clicked task');
    const isNewTask = task.isNew || id.toString().includes('$') || task.$new; // Adjust this condition based on your gantt library's behavior

    if (isNewTask) {
      gantt.deleteTask(id);
    }

    if (task.$level === 1) {
      setSelectedTask(isNewTask ? null : task);
      setCategoryModal(true);
    } else if (task.$level === 2) {
      router.push(`/gantt-chart/create-edit-activity/${task.parent.split('_')[0]}`);
    } else if (task.$level === 3) {
      setSelectedTask(isNewTask ? task : null);
      setSelectedDetails(isNewTask ? null : task);
      setTaskModal(true);
    } else {
    }
  };

  gantt.hideLightbox = () => {
    setTaskModal(false);
    setCategoryModal(false);
  };
};
